export default __webpack_public_path__ + "static/media/loading_white.c75f25cc.svg";